import { TOptions, t as t18 } from "i18next";

export const namespaces = [
  'stats', 'order', 'common', 'printer', 'auth', 'item', 'app'
]
  ;
export const AvailableLocales = ['en-GB'] as const;

export type AvailableLocaleType = (typeof AvailableLocales)[number];

export const tStats = {
  columns: {
    deliveryStatus(options: TOptions = {}) {
      return t18('stats:columns.deliveryStatus', options);
    },
    item(options: TOptions = {}) {
      return t18('stats:columns.item', options);
    },
    leftToDeliver(options: TOptions = {}) {
      return t18('stats:columns.leftToDeliver', options);
    },
  },
  errors: {
    loadError(options: TOptions = {}) {
      return t18('stats:errors.loadError', options);
    },
    notAuthorized(options: TOptions = {}) {
      return t18('stats:errors.notAuthorized', options);
    },
  },
  noItemsFound(options: TOptions = {}) {
    return t18('stats:noItemsFound', options);
  },
  period: {
    allPeriods(options: TOptions = {}) {
      return t18('stats:period.allPeriods', options);
    },
  },
  placesLimit(options: TOptions<{ max: string; } & Record<string, any>>) {
    return t18('stats:placesLimit', options);
  },
  searchPlaceholder(options: TOptions = {}) {
    return t18('stats:searchPlaceholder', options);
  },
  subtitle(options: TOptions = {}) {
    return t18('stats:subtitle', options);
  },
};
export const tOrder = {
  actions: {
    audioMute(options: TOptions = {}) {
      return t18('order:actions.audioMute', options);
    },
    audioUnmute(options: TOptions = {}) {
      return t18('order:actions.audioUnmute', options);
    },
    close(options: TOptions = {}) {
      return t18('order:actions.close', options);
    },
    confirm(options: TOptions = {}) {
      return t18('order:actions.confirm', options);
    },
    hideDetails(options: TOptions = {}) {
      return t18('order:actions.hideDetails', options);
    },
    orderRejected(options: TOptions = {}) {
      return t18('order:actions.orderRejected', options);
    },
    orderRejectedDescription(options: TOptions = {}) {
      return t18('order:actions.orderRejectedDescription', options);
    },
    play(options: TOptions = {}) {
      return t18('order:actions.play', options);
    },
    print(options: TOptions = {}) {
      return t18('order:actions.print', options);
    },
    ready(options: TOptions = {}) {
      return t18('order:actions.ready', options);
    },
    reject(options: TOptions = {}) {
      return t18('order:actions.reject', options);
    },
    statusUpdated(options: TOptions = {}) {
      return t18('order:actions.statusUpdated', options);
    },
    statusUpdatedDescription(options: TOptions = {}) {
      return t18('order:actions.statusUpdatedDescription', options);
    },
    statusUpdateError(options: TOptions = {}) {
      return t18('order:actions.statusUpdateError', options);
    },
    viewDetails(options: TOptions = {}) {
      return t18('order:actions.viewDetails', options);
    },
  },
  descriptions: {
    orderListSettings(options: TOptions<{ action: string; } & Record<string, any>>) {
      return t18('order:descriptions.orderListSettings', options);
    },
  },
  fields: {
    cardSize(options: TOptions = {}) {
      return t18('order:fields.cardSize', options);
    },
    groupByDate(options: TOptions = {}) {
      return t18('order:fields.groupByDate', options);
    },
    groupByNone(options: TOptions = {}) {
      return t18('order:fields.groupByNone', options);
    },
    groupByStatus(options: TOptions = {}) {
      return t18('order:fields.groupByStatus', options);
    },
    groupByTimeslot(options: TOptions = {}) {
      return t18('order:fields.groupByTimeslot', options);
    },
    itemFontSize(options: TOptions = {}) {
      return t18('order:fields.itemFontSize', options);
    },
    newOrderSound(options: TOptions = {}) {
      return t18('order:fields.newOrderSound', options);
    },
    showGuestName(options: TOptions = {}) {
      return t18('order:fields.showGuestName', options);
    },
    showItems(options: TOptions = {}) {
      return t18('order:fields.showItems', options);
    },
    showTimeParameters(options: TOptions = {}) {
      return t18('order:fields.showTimeParameters', options);
    },
    sortAscending(options: TOptions = {}) {
      return t18('order:fields.sortAscending', options);
    },
    sortByTime(options: TOptions = {}) {
      return t18('order:fields.sortByTime', options);
    },
    sortByVerification(options: TOptions = {}) {
      return t18('order:fields.sortByVerification', options);
    },
    sortDescending(options: TOptions = {}) {
      return t18('order:fields.sortDescending', options);
    },
    sortOrdersBy(options: TOptions = {}) {
      return t18('order:fields.sortOrdersBy', options);
    },
  },
  headers: {
    filter(options: TOptions = {}) {
      return t18('order:headers.filter', options);
    },
    fromDate(options: TOptions = {}) {
      return t18('order:headers.fromDate', options);
    },
    fromTime(options: TOptions = {}) {
      return t18('order:headers.fromTime', options);
    },
    period(options: TOptions = {}) {
      return t18('order:headers.period', options);
    },
    settings(options: TOptions = {}) {
      return t18('order:headers.settings', options);
    },
    toDate(options: TOptions = {}) {
      return t18('order:headers.toDate', options);
    },
    toTime(options: TOptions = {}) {
      return t18('order:headers.toTime', options);
    },
    total(options: TOptions = {}) {
      return t18('order:headers.total', options);
    },
  },
  orderCardSizeOptions: {
    large(options: TOptions = {}) {
      return t18('order:orderCardSizeOptions.large', options);
    },
    medium(options: TOptions = {}) {
      return t18('order:orderCardSizeOptions.medium', options);
    },
    small(options: TOptions = {}) {
      return t18('order:orderCardSizeOptions.small', options);
    },
  },
  orderDeliveryOption: {
    atCounter(options: TOptions = {}) {
      return t18('order:orderDeliveryOption.atCounter', options);
    },
    externalDelivery(options: TOptions = {}) {
      return t18('order:orderDeliveryOption.externalDelivery', options);
    },
    intracity(options: TOptions = {}) {
      return t18('order:orderDeliveryOption.intracity', options);
    },
    selfService(options: TOptions = {}) {
      return t18('order:orderDeliveryOption.selfService', options);
    },
    takeAway(options: TOptions = {}) {
      return t18('order:orderDeliveryOption.takeAway', options);
    },
    toCar(options: TOptions = {}) {
      return t18('order:orderDeliveryOption.toCar', options);
    },
    toTable(options: TOptions = {}) {
      return t18('order:orderDeliveryOption.toTable', options);
    },
  },
  orderHistory: {
    filterValidation: {
      dateInFuture(options: TOptions = {}) {
        return t18('order:orderHistory.filterValidation.dateInFuture', options);
      },
      endBeforeStart(options: TOptions = {}) {
        return t18('order:orderHistory.filterValidation.endBeforeStart', options);
      },
      invalidDateTime(options: TOptions = {}) {
        return t18('order:orderHistory.filterValidation.invalidDateTime', options);
      },
      timeWithoutDate(options: TOptions = {}) {
        return t18('order:orderHistory.filterValidation.timeWithoutDate', options);
      },
    },
    loadError(options: TOptions = {}) {
      return t18('order:orderHistory.loadError', options);
    },
    loadOrderError(options: TOptions = {}) {
      return t18('order:orderHistory.loadOrderError', options);
    },
    noOrdersFound(options: TOptions = {}) {
      return t18('order:orderHistory.noOrdersFound', options);
    },
    searchPlaceholder(options: TOptions = {}) {
      return t18('order:orderHistory.searchPlaceholder', options);
    },
    showingCount(options: TOptions<{ displayed: string; total: string; } & Record<string, any>>) {
      return t18('order:orderHistory.showingCount', options);
    },
    subtitle(options: TOptions = {}) {
      return t18('order:orderHistory.subtitle', options);
    },
  },
  orderList: {
    orderAwaiting(options: TOptions = {}) {
      return t18('order:orderList.orderAwaiting', options);
    },
    orderClosed(options: TOptions = {}) {
      return t18('order:orderList.orderClosed', options);
    },
    orderConfirmed(options: TOptions = {}) {
      return t18('order:orderList.orderConfirmed', options);
    },
    orderReady(options: TOptions = {}) {
      return t18('order:orderList.orderReady', options);
    },
    pickUp(options: TOptions = {}) {
      return t18('order:orderList.pickUp', options);
    },
    timeslotTruncated(options: TOptions = {}) {
      return t18('order:orderList.timeslotTruncated', options);
    },
    waitTime(options: TOptions = {}) {
      return t18('order:orderList.waitTime', options);
    },
  },
  orderStatus: {
    closed(options: TOptions = {}) {
      return t18('order:orderStatus.closed', options);
    },
    confirmed(options: TOptions = {}) {
      return t18('order:orderStatus.confirmed', options);
    },
    pending(options: TOptions = {}) {
      return t18('order:orderStatus.pending', options);
    },
    ready(options: TOptions = {}) {
      return t18('order:orderStatus.ready', options);
    },
    received(options: TOptions = {}) {
      return t18('order:orderStatus.received', options);
    },
    refunded(options: TOptions = {}) {
      return t18('order:orderStatus.refunded', options);
    },
    rejected(options: TOptions = {}) {
      return t18('order:orderStatus.rejected', options);
    },
  },
  periodOptions: {
    THIS_MONTH(options: TOptions = {}) {
      return t18('order:periodOptions.THIS_MONTH', options);
    },
    THIS_WEEK(options: TOptions = {}) {
      return t18('order:periodOptions.THIS_WEEK', options);
    },
    TODAY(options: TOptions = {}) {
      return t18('order:periodOptions.TODAY', options);
    },
  },
  tunes: {
    BELL(options: TOptions = {}) {
      return t18('order:tunes.BELL', options);
    },
    BOAT_HORN(options: TOptions = {}) {
      return t18('order:tunes.BOAT_HORN', options);
    },
    GOAT(options: TOptions = {}) {
      return t18('order:tunes.GOAT', options);
    },
    NOTIFICATION(options: TOptions = {}) {
      return t18('order:tunes.NOTIFICATION', options);
    },
  },
};
export const tCommon = {
  actions: {
    add(options: TOptions = {}) {
      return t18('common:actions.add', options);
    },
    allPlaces(options: TOptions = {}) {
      return t18('common:actions.allPlaces', options);
    },
    allStatuses(options: TOptions = {}) {
      return t18('common:actions.allStatuses', options);
    },
    apply(options: TOptions = {}) {
      return t18('common:actions.apply', options);
    },
    back(options: TOptions = {}) {
      return t18('common:actions.back', options);
    },
    clearAll(options: TOptions = {}) {
      return t18('common:actions.clearAll', options);
    },
    close(options: TOptions = {}) {
      return t18('common:actions.close', options);
    },
    confirm(options: TOptions = {}) {
      return t18('common:actions.confirm', options);
    },
    connect(options: TOptions = {}) {
      return t18('common:actions.connect', options);
    },
    disconnect(options: TOptions = {}) {
      return t18('common:actions.disconnect', options);
    },
    edit(options: TOptions = {}) {
      return t18('common:actions.edit', options);
    },
    filter(options: TOptions = {}) {
      return t18('common:actions.filter', options);
    },
    forget(options: TOptions = {}) {
      return t18('common:actions.forget', options);
    },
    goBack(options: TOptions = {}) {
      return t18('common:actions.goBack', options);
    },
    open(options: TOptions = {}) {
      return t18('common:actions.open', options);
    },
    print(options: TOptions = {}) {
      return t18('common:actions.print', options);
    },
    reject(options: TOptions = {}) {
      return t18('common:actions.reject', options);
    },
    save(options: TOptions = {}) {
      return t18('common:actions.save', options);
    },
    settings(options: TOptions = {}) {
      return t18('common:actions.settings', options);
    },
    viewDetails(options: TOptions = {}) {
      return t18('common:actions.viewDetails', options);
    },
  },
  descriptions: {
    preOrders(options: TOptions = {}) {
      return t18('common:descriptions.preOrders', options);
    },
    shopHasNoPlaces(options: TOptions = {}) {
      return t18('common:descriptions.shopHasNoPlaces', options);
    },
    xMinutesBefore(options: TOptions<{ minutes: string; } & Record<string, any>>) {
      return t18('common:descriptions.xMinutesBefore', options);
    },
  },
  general: {
    received(options: TOptions = {}) {
      return t18('common:general.received', options);
    },
    status(options: TOptions = {}) {
      return t18('common:general.status', options);
    },
  },
  headers: {
    edit(options: TOptions = {}) {
      return t18('common:headers.edit', options);
    },
    places(options: TOptions = {}) {
      return t18('common:headers.places', options);
    },
    preOrders(options: TOptions = {}) {
      return t18('common:headers.preOrders', options);
    },
    received(options: TOptions = {}) {
      return t18('common:headers.received', options);
    },
    status(options: TOptions = {}) {
      return t18('common:headers.status', options);
    },
  },
  notifications: {
    loading(options: TOptions = {}) {
      return t18('common:notifications.loading', options);
    },
  },
};
export const tPrinter = {
  actions: {
    addPrinter(options: TOptions = {}) {
      return t18('printer:actions.addPrinter', options);
    },
    status(options: TOptions = {}) {
      return t18('printer:actions.status', options);
    },
    test(options: TOptions = {}) {
      return t18('printer:actions.test', options);
    },
  },
  automaticPrinting: {
    doNotPrintAutomatically(options: TOptions = {}) {
      return t18('printer:automaticPrinting.doNotPrintAutomatically', options);
    },
    printAtConfirmation(options: TOptions = {}) {
      return t18('printer:automaticPrinting.printAtConfirmation', options);
    },
  },
  descriptions: {
    addPrinterToPrint(options: TOptions = {}) {
      return t18('printer:descriptions.addPrinterToPrint', options);
    },
    loadingPrinterStatus(options: TOptions = {}) {
      return t18('printer:descriptions.loadingPrinterStatus', options);
    },
    selectBrand(options: TOptions = {}) {
      return t18('printer:descriptions.selectBrand', options);
    },
    unknownModel(options: TOptions = {}) {
      return t18('printer:descriptions.unknownModel', options);
    },
  },
  errors: {
    disconnectError(options: TOptions = {}) {
      return t18('printer:errors.disconnectError', options);
    },
    invalidDisplayName(options: TOptions = {}) {
      return t18('printer:errors.invalidDisplayName', options);
    },
    invalidIp(options: TOptions = {}) {
      return t18('printer:errors.invalidIp', options);
    },
    noPrinterStored(options: TOptions = {}) {
      return t18('printer:errors.noPrinterStored', options);
    },
    noUsbPrinterFound(options: TOptions = {}) {
      return t18('printer:errors.noUsbPrinterFound', options);
    },
    printError(options: TOptions = {}) {
      return t18('printer:errors.printError', options);
    },
    setPrinterConnectionError(options: TOptions = {}) {
      return t18('printer:errors.setPrinterConnectionError', options);
    },
    testPrintError(options: TOptions = {}) {
      return t18('printer:errors.testPrintError', options);
    },
    unknownError(options: TOptions = {}) {
      return t18('printer:errors.unknownError', options);
    },
  },
  fields: {
    brand(options: TOptions = {}) {
      return t18('printer:fields.brand', options);
    },
    connectionType(options: TOptions = {}) {
      return t18('printer:fields.connectionType', options);
    },
    deviceName(options: TOptions = {}) {
      return t18('printer:fields.deviceName', options);
    },
    ipAddress(options: TOptions = {}) {
      return t18('printer:fields.ipAddress', options);
    },
    model(options: TOptions = {}) {
      return t18('printer:fields.model', options);
    },
  },
  headers: {
    automaticPrinting(options: TOptions = {}) {
      return t18('printer:headers.automaticPrinting', options);
    },
    newDevices(options: TOptions = {}) {
      return t18('printer:headers.newDevices', options);
    },
    printer(options: TOptions = {}) {
      return t18('printer:headers.printer', options);
    },
    printerStatus(options: TOptions = {}) {
      return t18('printer:headers.printerStatus', options);
    },
  },
  printerBrandType: {
    EPSON(options: TOptions = {}) {
      return t18('printer:printerBrandType.EPSON', options);
    },
    STAR(options: TOptions = {}) {
      return t18('printer:printerBrandType.STAR', options);
    },
  },
  printerConnectionType: {
    LAN(options: TOptions = {}) {
      return t18('printer:printerConnectionType.LAN', options);
    },
    USB(options: TOptions = {}) {
      return t18('printer:printerConnectionType.USB', options);
    },
  },
  printerSettings: {
    subtitle(options: TOptions = {}) {
      return t18('printer:printerSettings.subtitle', options);
    },
  },
  statusFields: {
    coverOpen(options: TOptions = {}) {
      return t18('printer:statusFields.coverOpen', options);
    },
    lowPaper(options: TOptions = {}) {
      return t18('printer:statusFields.lowPaper', options);
    },
    mechError(options: TOptions = {}) {
      return t18('printer:statusFields.mechError', options);
    },
    offline(options: TOptions = {}) {
      return t18('printer:statusFields.offline', options);
    },
    outOfPaper(options: TOptions = {}) {
      return t18('printer:statusFields.outOfPaper', options);
    },
    overTemp(options: TOptions = {}) {
      return t18('printer:statusFields.overTemp', options);
    },
    paperJam(options: TOptions = {}) {
      return t18('printer:statusFields.paperJam', options);
    },
    printerIsConnectedWithNoWarnings(options: TOptions = {}) {
      return t18('printer:statusFields.printerIsConnectedWithNoWarnings', options);
    },
    printerIsConnectedWithWarnings(options: TOptions = {}) {
      return t18('printer:statusFields.printerIsConnectedWithWarnings', options);
    },
    unrecoverableError(options: TOptions = {}) {
      return t18('printer:statusFields.unrecoverableError', options);
    },
  },
};
export const tAuth = {
  actions: {
    logIn(options: TOptions = {}) {
      return t18('auth:actions.logIn', options);
    },
    logOut(options: TOptions = {}) {
      return t18('auth:actions.logOut', options);
    },
  },
  fieldErrors: {
    invalidEmail(options: TOptions = {}) {
      return t18('auth:fieldErrors.invalidEmail', options);
    },
    invalidPassword(options: TOptions = {}) {
      return t18('auth:fieldErrors.invalidPassword', options);
    },
  },
  fields: {
    emailAddress(options: TOptions = {}) {
      return t18('auth:fields.emailAddress', options);
    },
    password(options: TOptions = {}) {
      return t18('auth:fields.password', options);
    },
  },
  notifications: {
    invalidCredentials(options: TOptions = {}) {
      return t18('auth:notifications.invalidCredentials', options);
    },
    sessionNoLongerValid(options: TOptions = {}) {
      return t18('auth:notifications.sessionNoLongerValid', options);
    },
    unableToLogin(options: TOptions = {}) {
      return t18('auth:notifications.unableToLogin', options);
    },
  },
};
export const tItem = {
  actions: {
    filterByStatus(options: TOptions = {}) {
      return t18('item:actions.filterByStatus', options);
    },
    sortBy(options: TOptions = {}) {
      return t18('item:actions.sortBy', options);
    },
  },
  errors: {
    loadError(options: TOptions = {}) {
      return t18('item:errors.loadError', options);
    },
    statusUpdateError(options: TOptions = {}) {
      return t18('item:errors.statusUpdateError', options);
    },
  },
  fields: {
    categories(options: TOptions = {}) {
      return t18('item:fields.categories', options);
    },
    itemId(options: TOptions = {}) {
      return t18('item:fields.itemId', options);
    },
    sortAscending(options: TOptions = {}) {
      return t18('item:fields.sortAscending', options);
    },
    sortDescending(options: TOptions = {}) {
      return t18('item:fields.sortDescending', options);
    },
  },
  list: {
    empty(options: TOptions = {}) {
      return t18('item:list.empty', options);
    },
  },
  status: {
    forSale(options: TOptions = {}) {
      return t18('item:status.forSale', options);
    },
    hidden(options: TOptions = {}) {
      return t18('item:status.hidden', options);
    },
    soldOut(options: TOptions = {}) {
      return t18('item:status.soldOut', options);
    },
  },
  tabs: {
    itemStatuses(options: TOptions = {}) {
      return t18('item:tabs.itemStatuses', options);
    },
  },
};
export const tApp = {
  app: {
    softwareVersion(options: TOptions = {}) {
      return t18('app:app.softwareVersion', options);
    },
    version(options: TOptions = {}) {
      return t18('app:app.version', options);
    },
  },
  drawer: {
    description(options: TOptions<{ action: string; } & Record<string, any>>) {
      return t18('app:drawer.description', options);
    },
    siteUnit(options: TOptions = {}) {
      return t18('app:drawer.siteUnit', options);
    },
    siteUnitsError(options: TOptions = {}) {
      return t18('app:drawer.siteUnitsError', options);
    },
  },
  errorPages: {
    notFound(options: TOptions = {}) {
      return t18('app:errorPages.notFound', options);
    },
    notFoundDescription(options: TOptions = {}) {
      return t18('app:errorPages.notFoundDescription', options);
    },
    unexpectedError(options: TOptions = {}) {
      return t18('app:errorPages.unexpectedError', options);
    },
    unexpectedErrorDescription(options: TOptions = {}) {
      return t18('app:errorPages.unexpectedErrorDescription', options);
    },
  },
  headers: {
    kitchenDisplay(options: TOptions = {}) {
      return t18('app:headers.kitchenDisplay', options);
    },
    orderHistory(options: TOptions = {}) {
      return t18('app:headers.orderHistory', options);
    },
    orders(options: TOptions = {}) {
      return t18('app:headers.orders', options);
    },
    printerSettings(options: TOptions = {}) {
      return t18('app:headers.printerSettings', options);
    },
    search(options: TOptions = {}) {
      return t18('app:headers.search', options);
    },
    settings(options: TOptions = {}) {
      return t18('app:headers.settings', options);
    },
    siteConfiguration(options: TOptions = {}) {
      return t18('app:headers.siteConfiguration', options);
    },
    stats(options: TOptions = {}) {
      return t18('app:headers.stats', options);
    },
  },
  shopStatus: {
    confirmOfflineContent(options: TOptions = {}) {
      return t18('app:shopStatus.confirmOfflineContent', options);
    },
    confirmOnlineContent(options: TOptions = {}) {
      return t18('app:shopStatus.confirmOnlineContent', options);
    },
    confirmTitle(options: TOptions = {}) {
      return t18('app:shopStatus.confirmTitle', options);
    },
    description(options: TOptions = {}) {
      return t18('app:shopStatus.description', options);
    },
    offline(options: TOptions = {}) {
      return t18('app:shopStatus.offline', options);
    },
    online(options: TOptions = {}) {
      return t18('app:shopStatus.online', options);
    },
    statusOffline(options: TOptions = {}) {
      return t18('app:shopStatus.statusOffline', options);
    },
    statusOnline(options: TOptions = {}) {
      return t18('app:shopStatus.statusOnline', options);
    },
    updateError(options: TOptions = {}) {
      return t18('app:shopStatus.updateError', options);
    },
    updateSuccess(options: TOptions = {}) {
      return t18('app:shopStatus.updateSuccess', options);
    },
  },
  tabs: {
    shopStatus(options: TOptions = {}) {
      return t18('app:tabs.shopStatus', options);
    },
  },
  theme: {
    dark(options: TOptions = {}) {
      return t18('app:theme.dark', options);
    },
    label(options: TOptions = {}) {
      return t18('app:theme.label', options);
    },
    light(options: TOptions = {}) {
      return t18('app:theme.light', options);
    },
  },
  unAuth: {
    header(options: TOptions = {}) {
      return t18('app:unAuth.header', options);
    },
    message(options: TOptions = {}) {
      return t18('app:unAuth.message', options);
    },
  },
};
